"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const SvgFilterFilledIcon = (0, react_1.forwardRef)((props, ref) => {
    return ((0, jsx_runtime_1.jsx)("svg", Object.assign({ xmlns: 'http://www.w3.org/2000/svg', viewBox: '0 0 25 22', ref: ref }, props, { children: (0, jsx_runtime_1.jsx)("path", { fill: 'currentColor', fillRule: 'nonzero', d: 'M.19 1.125A1.94 1.94 0 0 1 1.953 0H23.05c.757 0 1.44.437 1.763 1.125a1.98 1.98 0 0 1-.254 2.087l-8.931 10.975v6.242c0 .594-.332 1.14-.865 1.405a1.55 1.55 0 0 1-1.636-.148l-3.125-2.357a1.56 1.56 0 0 1-.625-1.257v-3.885L.439 3.207A1.97 1.97 0 0 1 .19 1.125' }) })));
});
exports.default = (0, react_1.memo)(SvgFilterFilledIcon);
